import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { HttpCallService } from "@services/http-calls.service";
import { HelperService } from "@services/helper.service";
import { first } from "rxjs/operators";
import _ from "lodash";
import { TestToolDetailsComponent } from "../../../pages/service-tools-management/test-tool/details/details.component";

@Component({
	selector: "RevertStorageLocationModal",
	templateUrl: "./RevertStorageLocationModal.component.html",
	styleUrls: ["./RevertStorageLocationModal.component.scss"],
})
export class RevertStorageLocationModal implements OnInit {
	@Input() title;
	@Input() description;

	@Input() btnYesLabel = "Yes";
	@Input() btnYesClasses = "p-button-primary";
	@Input() btnNoLabel = "No";
	@Input() btnNoClasses = "p-button-secondary";
	@Input() selectedLabel;
	@Output() responseSuccess = new EventEmitter();
	@Output() locationListReverted: EventEmitter<string[]> = new EventEmitter<
		string[]
	>();

	@ViewChild("RevertStorageLocationModal") localModal;

	input_searching = false;
	location_listing = [];
	isInit = false;

	constructor(
		private httpCallService: HttpCallService,
		private helperService: HelperService,
		private testToolComponent: TestToolDetailsComponent
	) {}

	ngOnInit(): void {
		let requestParams = {
			per_page: 99999,
		};
		let tempSubscription = this.helperService
			.getListing("storage-locations", requestParams)
			.pipe(first())
			.subscribe((response: any) => {
				this.location_listing = _.get(response, "data.data", []);
				tempSubscription.unsubscribe();
			});
	}

	promiseResolve = null;
	resolve = null;
	reject = null;

	REVERT_LOCATION_OPTIONS = [];

	currentRevertLoc: any = [];

	openModal() {
		if (this.location_listing != null) {
			const item = this.location_listing.find((item) => {
				return (
					item["location_name"] ===
					this.testToolComponent.testTool["last_from_by_name"]
				);
			});
			if (item != null) {
				this.currentRevertLoc = item;
			}
		}

		setTimeout(() => {
			this.localModal.show();
			return new Promise((resolve, reject) => {
				this.promiseResolve = resolve;
				this.resolve = resolve;
				this.reject = reject;
			});
		}, 100);
	}

	confirm() {
		this.responseSuccess.emit(true);
		this.locationListReverted.emit(this.currentRevertLoc);
		this.promiseResolve(true);
		this.resolve(true);
		this.localModal.hide();
		this.currentRevertLoc = null;
	}
}
